<template>
  <div class="mines-tile">
    <transition name="flip" mode="out-in">
      <!-- COIN TILE (açılan) -->
      <div
        v-if="minesGame !== null && minesGetRevealedTile === 'coin'"
        class="tile-coin"
      >
        <div class="coin-box">
          <div class="box-inner">
            <div v-if="isLastRevealed" class="multiplier-badge">
              {{ minesGetTileMultiplier.toFixed(2) }}x
            </div>
            <img src="@/assets/img/rivocoin.png" />
          </div>
        </div>
      </div>

      <!-- MINE TILE -->
      <div
        v-else-if="minesGame !== null && minesGetRevealedTile === 'mine'"
        class="tile-mine"
      >
        <img src="@/assets/img/mines/mine.png" />
      </div>

      <!-- TAMAMLANMIŞ OYUNDA AÇILMAMIŞ COINLER -->
      <div
        v-else-if="minesGame !== null && minesGame.state === 'completed' && minesGame.deck[tile] === 'coin'"
        class="tile-coin dimmed"
      >
        <img src="@/assets/img/rivocoin.png" />
      </div>

      <!-- KAPALI TILE -->
      <button
        v-else
        v-on:click="minesRevealTile()"
        class="button-reveal"
        :disabled="socketSendLoading !== null || minesGame === null || minesGame.state === 'completed'"
      >
        <img src="@/assets/img/logo_small.png" />
      </button>
    </transition>
  </div>
</template>


<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'MinesTile',
  props: ['tile'],
  methods: {
    ...mapActions([
      'notificationShow',
      'minesSendRevealSocket'
    ]),
    minesRevealTile() {
      if (this.authUser.user === null) {
        this.notificationShow({ type: 'error', message: 'Please sign in to perform this action.' });
        return;
      }

      if (this.minesGame === null) {
        this.notificationShow({ type: 'error', message: 'You have no running mines game at the moment.' });
        return;
      }

      const data = { tile: this.tile };
      this.minesSendRevealSocket(data);
    },
    minesFactorialNumber(number) {
      let value = number;
      for (let i = number; i > 1; i--) {
        value = value * (i - 1);
      }
      return value;
    }
  },
  computed: {
    ...mapGetters([
      'socketSendLoading',
      'authUser',
      'minesGame'
    ]),

    minesGetRevealedTile() {
      let revealed = null;

      if (this.minesGame.state === 'completed' && this.minesGame.deck[this.tile] === 'mine') {
        revealed = this.minesGame.deck[this.tile];
      } else {
        const index = this.minesGame.revealed.findIndex((element) => element.tile === this.tile);
        if (index !== -1) {
          revealed = this.minesGame.revealed[index].value;
        }
      }
      return revealed;
    },

    // Çarpanı hesapla
    minesGetTileMultiplier() {
      const index = this.minesGame.revealed.findIndex((element) => element.tile === this.tile);
      if (index === -1) return 1;

      const first = 25 === (index + 1)
        ? 1
        : this.minesFactorialNumber(25) /
          (this.minesFactorialNumber(index + 1) *
           this.minesFactorialNumber(25 - (index + 1)));

      const second = (25 - this.minesGame.minesCount) === (index + 1)
        ? 1
        : this.minesFactorialNumber(25 - this.minesGame.minesCount) /
          (this.minesFactorialNumber(index + 1) *
           this.minesFactorialNumber((25 - this.minesGame.minesCount) - (index + 1)));

      let multiplier = 0.95 * (first / second);
      multiplier = multiplier < 1 ? 1 : multiplier;

      return multiplier;
    },

    // sadece en son açılan tile bu mu?
    isLastRevealed() {
      if (!this.minesGame || !this.minesGame.revealed.length) return false;
      const lastTile = this.minesGame.revealed[this.minesGame.revealed.length - 1];
      return lastTile.tile === this.tile;
    }
  }
}
</script>

<style scoped>
.mines-tile {
  width: 95px;
  height: 95px;
  border-radius: 7px;
  background: var(--background2);
  box-shadow: 0px 2px 5px rgba(7, 26, 41, 0.25);
  position: relative; /* badge için gerekli */
  perspective: 800px; /* flip animasyonu için */
}

/* Çarpan badge */
.multiplier-badge {
  position: absolute;
  top: -10px;
  right: -10px;
  background: var(--buttonyellow);
  color: #000;
  font-weight: 800;
  font-size: 13px;
  padding: 2px 6px;
  border-radius: 6px;
  box-shadow: 0 2px 6px rgba(0,0,0,0.25);
  z-index: 5;
}

.mines-tile .tile-coin,
.mines-tile .tile-mine {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 7px;
  padding: 9px;
}

.mines-tile .tile-mine {
  background: radial-gradient(230% 105% at 50% 15%, rgba(0,0,0,0.22) 0%, rgba(0,0,0,0.28) 30%, rgba(0,0,0,0.26) 65%, rgba(0,0,0,0) 100%),
              linear-gradient(0deg, rgba(222,35,35,0.39) -30%, rgba(222,68,34,0.39) -16%, rgba(167,43,35,0.22) 30%, rgba(0,0,0,0) 100%),
              rgba(0,0,0,0.02);
  border: 1px solid rgba(222,68,34,0.5);
  box-shadow: 0px 2px 2px rgba(0,0,0,0.15), 0px 2px 5px rgba(7,26,41,0.25), inset 0px 0px 56px rgba(146,25,25,0.6);
}

.mines-tile .coin-box {
  width: 100%;
  height: 100%;
  position: relative;
  border-radius: 7px;
  z-index: 1;
}

.mines-tile .box-inner {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 7px;
}

.mines-tile .box-inner img {
  width: 70px;
}

.mines-tile .tile-mine img {
  width: 100%;
}

.mines-tile button.button-reveal {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.mines-tile button.button-reveal img {
  width: 48px;
  transform: rotate(-4deg);
  mix-blend-mode: luminosity;
  opacity: 0.13;
  transition: transform 0.3s ease;
}

.mines-tile button.button-reveal:enabled:hover img {
  transform: scale(1.08);
}

/* Flip animasyon */
.flip-enter-active,
.flip-leave-active {
  transition: transform 0.2s;
  transform-style: preserve-3d;
}

.flip-enter-from {
  transform: rotateY(90deg);
}

.flip-enter-to {
  transform: rotateY(0deg);
}

.flip-leave-from {
  transform: rotateY(0deg);
}

.flip-leave-to {
  transform: rotateY(-90deg);
}

/* Responsive */
@media only screen and (max-width: 575px) {
  .mines-tile { width: 70px; height: 70px; }
  .box-inner img { width: 46px !important;  }
  .multiplier-badge { font-size: 11px; top: -8px; right: -8px; }
}

@media only screen and (max-width: 425px) {
  .mines-tile { width: 60px; height: 60px; }
  .box-inner img { width: 42px !important; }
  .multiplier-badge { font-size: 10px; }
}

@media only screen and (max-width: 350px) {
  .mines-tile { width: 50px; height: 50px; }
  .box-inner img { width: 38px !important; }
}

.dimmed {
  position: relative;
  animation: dimFadeIn 0.1s ease forwards;
}

.dimmed img {
  width: 55px !important; /* normalde 70px ise küçültülmüş */
  opacity: 0.6;
  filter: grayscale(40%);
}

.dimmed::after {
  content: "";
  position: absolute;
  inset: 0;
  background: rgba(0,0,0,0.45);
  border-radius: 7px;
  pointer-events: none;
}

/* Fade-in animasyonu */
@keyframes dimFadeIn {
  from {
    opacity: 0;
    transform: scale(0.9);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}


</style>
